import { Checkbox, Form, Input, InputNumber, Select, Switch } from "antd";
import { useGetMaterialCommonList } from "features/material-details/use-cases/get-commonmasterlist";
import { FormSectionsSeparator } from "features/users/components/modals/form-sections-separator";

export const MatrialDetailsInfoFormItems = ({ selectedType, setSelectedType, matrialEditData }: any) => {
  const formatText = (value: string) => {
    if (!value) return "";
    const trimmed = value.trim();
    
return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
  };

  const commonFlags = {
    materialDetailType: "MaterialDetailType", // Sales / Purchase
    loadMaterialType: "AdminLoadMaterialType", // Sales => Material Names
    unloadMaterialType: "AdminUnloadMaterialType", // Purchase => Material Names
  };

  // Determine active type for rendering fields
  const activeType = selectedType || matrialEditData?.materialType;

  // Fetch Material Types (Sales / Purchase)
  const { data: materialDetailType } = useGetMaterialCommonList({
    Flag: commonFlags.materialDetailType,
  } as any);

  // Flag for fetching material names
  const flag =
    activeType === "Sales"
      ? commonFlags.loadMaterialType
      : activeType === "Purchase"
        ? commonFlags.unloadMaterialType
        : "";

  // Fetch Material Names dynamically
  const { data: materialNameList } = useGetMaterialCommonList(
    { Flag: flag } as any,
    { enabled: !!flag }
  );

  return (
    <FormSectionsSeparator title="">
      {/* Material Type Dropdown */}
      <Form.Item
        name="materialType"
        label="Material Type"
        rules={[{ required: true, message: "Please select material type" }]}
      >
        <Select
          placeholder="Select Type"
          options={materialDetailType?.res?.commonList.map((item: any) => ({
            label: item.title, // "Sales" / "Purchase"
            value: item.title, // ✅ use title instead of id
          }))}
          value={selectedType || matrialEditData?.materialType} // initial value from edit data
          onChange={(value) => setSelectedType(value)}
        />
      </Form.Item>

      {/* Material Name Dropdown */}
      <Form.Item
        name="materialId"
        label="Material Name"
        rules={[{ required: true, message: "Please select material name" }]}
      >
        <Select
          placeholder="Select Name"
          options={materialNameList?.res?.commonList.map((item: any) => ({
            label: item.title,
            value: item.id,
          }))}
        />
      </Form.Item>

      {/* Description */}
      <Form.Item
        name="description"
        label="Material Detail"
        rules={[{ required: true, whitespace: true, message: "Please enter detail" }]}
        getValueFromEvent={(e) => formatText(e.target.value)}
      >
        <Input placeholder="Enter Material Detail" />
      </Form.Item>

      {/* Fields for Sales */}
      {activeType === "Sales" && (
        <>
          <Form.Item
            name="purity"
            label="Purity"
            rules={[{ required: true, message: "Please enter purity" }]}
          >
            <InputNumber
              min={1}
              max={100}
              placeholder="Enter purity (1 - 100)"
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            name="bundleSize"
            label={
              <>
                Bundle Size
                <span style={{ marginLeft: "5px" }}>(How many pcs in bundle)</span>
              </>
            }
            rules={[
              { required: true, message: "Please enter bundle size" },
              { pattern: /^[0-9]+$/, message: "Enter valid number" },
            ]}
          >
            <Input placeholder="Enter bundle size" />
          </Form.Item>

          <Form.Item
            name="tonSize"
            label={
              <>
                Ton Size
                <span style={{ marginLeft: "5px" }}>(How many pcs in ton)</span>
              </>
            }
            rules={[
              { required: true, message: "Please enter ton size" },
              { pattern: /^[0-9]+(\.[0-9]+)?$/, message: "Enter valid number" },
            ]}
          >
            <Input placeholder="Enter ton size" />
          </Form.Item>

          <Form.Item
            name="bundlePrice"
            label={
              <>
                Bundle Price
                <span style={{ marginLeft: "5px" }}>(Enter bundle price)</span>
              </>
            }
            rules={[
              { required: true, message: "Please enter bundle price" },
              { pattern: /^[0-9]+(\.[0-9]+)?$/, message: "Enter valid number" },
            ]}
          >
            <Input placeholder="Enter bundle price" />
          </Form.Item>
        </>
      )}

      {/* Fields for Purchase */}
      {activeType === "Purchase" && (
        <Form.Item
          name="isVerification"
          valuePropName="checked"
          label="Is Verification"
        >
          <Checkbox />
        </Form.Item>
      )}
      <Form.Item name={"status"} label="isActive">
        <Switch
          defaultChecked
         
        />
      </Form.Item>
    </FormSectionsSeparator>
  );
};
